<template>
  <el-table-column
    prop="status"
    sortable="custom"
    label="Státusz"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.status === 'waiting-for-inward'" size="small" type="info">Bevételezésre vár</el-tag>
      <el-tag v-if="scope.row.status === 'done'" size="small" type="success">Teljesítve</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'status',
  };
</script>
